import { createSelector } from "@reduxjs/toolkit";
import { IAccommodationRoom } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";

import { IDataKeys } from "shared/types";
import { buildData } from ".";
import { dataSelector } from "./helpers";

export const customAccommodationRoomsSelectorForBlock = () =>
  createSelector(dataSelector, (data) => {
    const rooms = (buildData(data as any, IDataKeys.eventAccommodationRoom) ||
      []) as IAccommodationRoom[];

    return rooms;
  });

export const customAccommodationRoomsSelectorCreator = (
  roomType: string,
  nbPeople?: number,
  currentRoom?: string
) =>
  createSelector(dataSelector, (data) => {
    let rooms = (buildData(data as any, IDataKeys.eventAccommodationRoom) ||
      []) as IAccommodationRoom[];

    if (!roomType || !nbPeople) return [];

    rooms = rooms.filter(
      (room) =>
        room.roomType.id ===
        API_ENDPOINTS.EVENT_ACCOMMODATION_ROOM_TYPE(roomType)
    );
    rooms = rooms.filter(
      (room) => room.vacancy >= nbPeople || room.id === currentRoom
    );

    return rooms;
  });
